import { createQueryOptions } from "@packages/core-client/api/createQueryOptions.ts";
import { useHasProduct } from "@packages/core-client/session/SessionContext.tsx";
import { retryUnlessNotFound } from "@packages/core-client/query/retryUnlessNotFound.ts";
import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { useMatches } from "react-router";
import { useDirectoryClient } from "../../../api/queries/directory.ts";

const REVIEWS_TAB_ID = "reviews";
const GOOD_VIBES_TAB_ID = "good-vibes";
const GOALS_TAB_ID = "goals";
const ENGAGEMENT_TAB_ID = "engagement";
const PROGRESSION_TAB_ID = "progression";

export function useIsProfileTabHidden() {
    const matches = useMatches();
    const personId = matches[matches.length - 1]?.params?.personId ?? "";

    const { queryUtils } = useDirectoryClient();
    const { data } = useQuery(
        createQueryOptions(queryUtils.getProfile.queryOptions({ input: { personId } }), {
            throwOnError: false,
            retry: retryUnlessNotFound
        })
    );

    const hasOfficevibe = useHasProduct("wov");
    const hasPerformance = useHasProduct("wpm");

    const canViewReviews = data?.canViewReviews;
    const isSelf = data?.isSelf;

    return useCallback(
        (tabId: string) => {
            if (tabId === REVIEWS_TAB_ID) {
                return !hasPerformance || !canViewReviews || !!isSelf;
            }

            if (tabId === GOOD_VIBES_TAB_ID) {
                return !hasOfficevibe || !!isSelf;
            }

            if (tabId === GOALS_TAB_ID) {
                return !hasPerformance || !!isSelf;
            }

            if (tabId === ENGAGEMENT_TAB_ID) {
                return !hasOfficevibe || !isSelf;
            }

            if (tabId === PROGRESSION_TAB_ID) {
                return !isSelf;
            }

            return false;
        },
        [canViewReviews, hasOfficevibe, hasPerformance, isSelf]
    );
}
